import { useEffect } from "react"

import { useCart } from "lib/cart"
import { useAuth } from "lib/auth"
import { useVideoPlayer } from "lib/video-player"
import { useProducts } from "lib/products"
import { useCountry } from "lib/country"
import { useAccesses } from "lib/accesses"

const ProductAccessAutoplay = ({ product, audioDescription }) => {
	const { addToCart } = useCart()
	const { user } = useAuth()
	const { hasAccessToProduct } = useAccesses()
	const { purchasable, originalCountry, showAnotherCountry } = useCountry()
	const { seeFilm } = useVideoPlayer()
	const { isAvailable } = useProducts()
	const available = product.available || isAvailable(product)

	useEffect(() => {
		if (!user) {
			return
		}

		hasAccessToProduct(product)
			.then(access => {
				if (access) {
					setTimeout(() => {
						seeFilm(product, false, [], audioDescription)
					}, 2000)

					return
				}

				if (!originalCountry) {
					showAnotherCountry()
					return
				}

				if (!purchasable || !available) {
					return
				}

				setTimeout(() => {
					addToCart(product)
				}, 2000)
			})
	}, [user])

	return null
}

export default ProductAccessAutoplay
